import axios from 'axios'
import React from 'react'
import { baseUrl } from '../../assets/Animations'
import { taskChipCheckOffAnimation } from '../adminTaskUtils'
import './task-chip-2023.css'
import ConfettiExplosion from 'react-confetti-explosion';
import AreYouSureYouAreDone from '../AreYouSureYouAreDone/AreYouSureYouAreDone'

const myToken = localStorage.getItem('token')
const myHeader = {headers: { Authorization: `Bearer ${myToken}` }}

const TaskChip2023 = ({todo, setOpenModal2023, setTodos, getNotesAboutModal}) => {
    const [isConfettiExplosion, setIsConfettiExplosion] = React.useState(false)
    const [isWarning, setIsWarning] = React.useState(false)

    React.useEffect(() => isConfettiExplosion && setTimeout(() => {setIsConfettiExplosion(false)}, 2000), [isConfettiExplosion])

    const checkBoxAndDeleteTask = () => {
        setIsWarning(false)
        setIsConfettiExplosion(true)
        taskChipCheckOffAnimation(`task-card-${todo.todoId}`)
        axios.delete(`${baseUrl}/tasks/${todo.todoId}`, myHeader)
        .then((res) => {setTimeout(() => {setTodos(prev => (prev.map((prevTodo) => prevTodo.todoId !== res.data.todoId && prevTodo)))}, 1500)})
        .catch((err) => console.log(err))
    }

    const openUpTheTask = () => {
        getNotesAboutModal(todo.todoId, 'tasksId', todo.todoName)
        setOpenModal2023(todo)
    }

    return(
        <div>
            {isConfettiExplosion && <ConfettiExplosion />}
            {isWarning && <AreYouSureYouAreDone setIsWarning={setIsWarning} checkBoxAndDeleteTask={checkBoxAndDeleteTask} />}
            <div className='task-chip-2023' id={`task-card-${todo.todoId}`} onClick={(e) => (e.target.id !== 'task-chip-2023__check-box' && openUpTheTask())}>
                <div className='task-chip-2023__check-box' id='task-chip-2023__check-box' onClick={todo.todoSubtasks.filter(task => !task.subtaskCompleted && task ).length !== 0 ? () => setIsWarning(true) : () => checkBoxAndDeleteTask()}></div>
                <div className='task-chip-2023__name'>{todo.todoName}</div>
                {todo.todoSubtasks.filter(task => !task.subtaskCompleted && task ).length !== 0 && <div className='task-chip-2023__tasks-left'>{(todo.todoSubtasks.filter(task => !task.subtaskCompleted && task )).length}</div>}
            </div>
        </div>
    )
}
export default TaskChip2023